module.exports = __webpack_public_path__ + "static/doble-meseros-eed2ee6f5e504f4ecda2db74fc0b094d.jpg";